/*
 * Copyright (C) America Móvil S.A.B de C.V - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Juan Manuel Garcia Junco Moreno <manue.garcia@ironbit.com.mx>, May 2020
 * and modified by Mariano Lopez China Santiago <mchina_ext@amco.mx, May 2020
 */
import { IHttpClientResponse, HttpClient } from './HttpClient';
import { HttpError } from './HttpError';
import { Body } from './Body';
import { IRequestOptions } from './Request';
import { Headers } from './Headers';

export class XhrClient extends HttpClient {
    protected send<T extends string | FormData | Record<string, unknown>>(request: IRequestOptions<T>): Promise<IHttpClientResponse<Body>> {
        const xhr = new XMLHttpRequest();
        const { headers, url, method, statusCode400As200, statusCode401As200, statusCode409As200, statusCode422As200, statusCode304As200, statusCode429As200, statusCode404As200, statusCode402As200, statusCode500As200, statusCode501As200, responseType, retries } = request;
        xhr.open(method.toLowerCase(), url.toString());
        // Set request headers.
        headers.forEach((value, name) => {
            xhr.setRequestHeader(name, value);
        });
        xhr.responseType = responseType;

        return new Promise((resolve, reject) => {
            xhr.onerror = (error: ProgressEvent<EventTarget>): void => {
                reject(error);
            };
            xhr.onreadystatechange = (): void => {

                
                if (!xhr || xhr.readyState !== 4) {
                    return;
                }
                const rawHeaders = xhr.getAllResponseHeaders();
                const responseHeaders = new Headers(rawHeaders);
                const response  = responseType === 'arraybuffer' ? xhr.response: xhr.responseText;
                let body = new Body(responseHeaders, response);
                let status: number = xhr.status;

                if((statusCode400As200 && status === 400)|| (statusCode409As200 && status === 409)){
                    status = 200
                }
                if(statusCode401As200 && status === 401){
                    status = 200
                }
                if(statusCode422As200 && status === 422){
                  status = 200
                }
                if(statusCode304As200 && status === 304) {
                    status = 200;
                }
                if(statusCode404As200 && status === 404) {
                    status = 200;
                }
                if(statusCode429As200 && status === 429) {
                    status = 200;
                    body = new Body(responseHeaders, "{\"response\": {\"errors\": {\"msg\": \"Too many requests - HttpStatus 429\"}}}");
                }
                if(statusCode402As200 && status === 402) {
                    status = 200;
                }
                if(statusCode500As200 && status === 500 && retries === 0) {
                    status = 200;
                }
                if(statusCode501As200 && status === 501) {
                    status = 200;
                }

                // *************************************************************
                // transforma respuesta 500 con código de error "loggin_required"
                let isJson = true;
                let parsedResponse = null;
                try {
                    parsedResponse = JSON.parse(response);
                } catch (err) {
                    isJson = false
                }
                if(status === 500 && isJson && parsedResponse.errors && parsedResponse.errors.code === "loggin_required") {
                    status = 200;
                    body = new Body(responseHeaders, response);
                }
                // *************************************************************

                if (status >= 200 && status < 300) {
                    const response: IHttpClientResponse<Body> = {
                        status,
                        body,
                        headers: responseHeaders
                    };

                    resolve(response);
                } else {
                    console.log("Body from XhrClient", body, "statusText", xhr.statusText)
                    console.log("HttpError from XhrClient: ", new HttpError(xhr.statusText, body))
                    reject(new HttpError(xhr.statusText, body));
                }
            };

            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            xhr.send(request.body as any);
        });
    }
}



// WEBPACK FOOTER //
// ./src/packages/http/lib/XhrClient.ts